import { cn } from '@/utils';

function Title({ className, ...props }) {
	return (
		<span>
			<p
				className={cn(
					'mb-1 font-title text-base font-semibold leading-7 md:mb-3 md:text-[32px] md:leading-[40px] md:-tracking-[1px]',
					className
				)}
				{...props}
			/>
		</span>
	);
}

export default Title;
